<template>
  <section
    v-if="links.length > 1"
    class="flex h-50 items-center md:mt-20 print:hidden"
  >
    <nav
      class="is-wide container overflow-auto"
      :aria-label="$texts('breadcrumb', 'Breadcrumb')"
    >
      <ol
        itemscope
        itemtype="http://schema.org/BreadcrumbList"
        class="flex items-center whitespace-nowrap"
      >
        <li
          v-for="(link, index) in links"
          :key="index"
          class="text-hero flex h-50 items-center"
          itemprop="itemListElement"
          itemscope
          itemtype="http://schema.org/ListItem"
        >
          <NuxtLink v-if="index === 0" :to="{ name: 'home' }" class="icon">
            <SpriteSymbol name="home" class="size-16" />
            <span itemprop="name" class="sr-only">
              {{ link.title }}
            </span>
          </NuxtLink>
          <template v-else>
            <DrupalLink
              :to="link.url.path"
              itemprop="item"
              class="flex items-center"
            >
              <SpriteSymbol name="arrow-right" class="mx-15 size-16" />
              <span itemprop="name">
                {{ link.title }}
              </span>
            </DrupalLink>
          </template>
        </li>
      </ol>
    </nav>
  </section>
</template>

<script lang="ts" setup>
import type { BreadcrumbFragment } from '#graphql-operations'

defineProps<{
  links: BreadcrumbFragment[]
}>()
</script>
